import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Home from "./Pages/Home";
import FAQ from "./Pages/faq";
import Awards from "./Pages/awards";

function App() {

	return (
		<div>
			<BrowserRouter>
				<Routes>

					<Route path='/' element={<Home />} />
					<Route path='/faq' element={<FAQ />} />
					<Route path='/awards' element={<Awards />} />

				</Routes>
			</BrowserRouter>
			<div>

			</div>
		</div>

	)
}

export default App;
